import { useContext } from 'react';
import { PageContext } from 'contexts';
import { MusicLink } from 'components/MusicLink';
import { GO_COOKIE_PREFERENCES } from 'constants/metrics';
import { FormattedMessage } from 'react-intl';
import { getCookiePrefUrl } from 'utils/url';
import { useSelector } from 'react-redux';
import { localeSelector } from 'store/selectors/locale';

const CookiePreferences = () => {
  const page = useContext(PageContext);
  const locale = useSelector(localeSelector);
  const cookiePrefLink = getCookiePrefUrl(locale);

  return (
    <MusicLink
      href={cookiePrefLink}
      kind="accent"
      data-id={`${GO_COOKIE_PREFERENCES}-${page}`}
    >
      <FormattedMessage
        id="cookie-preferences"
        defaultMessage="Cookie Preferences"
      />
    </MusicLink>
  );
};

export default CookiePreferences;
